import { useState } from 'react';

export const useVirtualModel = () => {
    const [selectedUnit, setSelectedUnit] = useState(null);

    const units = [
        { id: 1, number: '1001', type: '2 quartos', area: '76m²', status: 'available', price: 'R$ 65.000', weekPrice: 'R$ 780.000', weeks: 12, floor: 10, position: { top: '20%', left: '25%' } },
        { id: 2, number: '1002', type: '3 quartos', area: '98m²', status: 'sold', price: 'R$ 89.000', weekPrice: 'R$ 1.068.000', weeks: 0, floor: 10, position: { top: '20%', left: '45%' } },
        { id: 3, number: '1003', type: '1 quarto', area: '55m²', status: 'reserved', price: 'R$ 45.000', weekPrice: 'R$ 540.000', weeks: 4, floor: 10, position: { top: '20%', left: '65%' } },
        { id: 4, number: '1004', type: '2 quartos', area: '76m²', status: 'available', price: 'R$ 65.000', weekPrice: 'R$ 780.000', weeks: 12, floor: 10, position: { top: '60%', left: '25%' } },
        { id: 5, number: '1005', type: '3 quartos', area: '98m²', status: 'available', price: 'R$ 89.000', weekPrice: 'R$ 1.068.000', weeks: 8, floor: 10, position: { top: '60%', left: '45%' } },
        { id: 6, number: '1006', type: '1 quarto', area: '55m²', status: 'sold', price: 'R$ 45.000', weekPrice: 'R$ 540.000', weeks: 0, floor: 10, position: { top: '60%', left: '65%' } },
        { id: 7, number: '901', type: '2 quartos', area: '76m²', status: 'available', price: 'R$ 62.000', weekPrice: 'R$ 744.000', weeks: 10, floor: 9, position: { top: '20%', left: '25%' } },
        { id: 8, number: '902', type: '3 quartos', area: '98m²', status: 'sold', price: 'R$ 86.000', weekPrice: 'R$ 1.032.000', weeks: 0, floor: 9, position: { top: '20%', left: '45%' } }
    ];

    const getStatusColor = (status) => {
        switch (status) {
            case 'available':
                return 'bg-green-500';
            case 'reserved':
                return 'bg-yellow-500';
            case 'sold':
                return 'bg-red-500';
            default:
                return 'bg-gray-500';
        }
    };

    const getUnitsByFloor = (floorNumber) => {
        return units.filter(unit => unit.floor === floorNumber);
    };

    const handleUnitClick = (unit) => {
        setSelectedUnit(unit);
    };

    const getUnitById = (unitId) => {
        return units.find(unit => unit.id === unitId);
    };

    return {
        units,
        selectedUnit,
        getStatusColor,
        getUnitsByFloor,
        handleUnitClick,
        getUnitById
    };
};

export default useVirtualModel;